var FolderNameValidationResult;
(function(FolderNameValidationResult) {
    FolderNameValidationResult["Good"] = "good";
    FolderNameValidationResult["Empty"] = "empty";
    FolderNameValidationResult["TooLong"] = "long";
    FolderNameValidationResult["InvalidCharacters"] = "invalid";
    FolderNameValidationResult["Blacklisted"] = "blacklist";
})(FolderNameValidationResult || (FolderNameValidationResult = {}));
export const MAX_TITLE_LENGTH = 50;
// the following is based on the backend logic, we should try to keep
// it in sync
function isValidFolderName(input, blacklistedNames = []) {
    const name = input.trim();
    if (!name || !name.length) {
        return "empty";
    }
    if (name.length > MAX_TITLE_LENGTH) {
        return "long";
    }
    if (!/^[ \w$?:.,'"\-+]+$/.test(name)) {
        return "invalid";
    }
    if ([
        'favourites',
        'featured',
        ...blacklistedNames.map((n)=>n.toLowerCase())
    ].includes(name.toLowerCase())) {
        return "blacklist";
    }
    return "good";
}
export function getFolderNameValidationErrorMessage(name, t, blacklistedNames = [], isGallery) {
    const result = isValidFolderName(name, blacklistedNames);
    switch(result){
        case "empty":
            return t('collectionPanel.error.emptyName');
        case "long":
            return t('collectionPanel.error.longName');
        case "invalid":
            return t('collectionPanel.error.invalidCharacters');
        case "blacklist":
            if (isGallery) {
                return t('collectionPanel.error.blacklisted.gallery', {
                    name
                });
            }
            return t('collectionPanel.error.blacklisted.collection', {
                name
            });
        default:
            return;
    }
}

//# sourceMappingURL=isValidFolderName.js.map